module.exports = __webpack_public_path__ + "assets/invitation-code.7f9d3a94.svg";